export interface DataEntity_Main_11_01_Interface {
    id: number,
    calibration_id: number,
    manufacture: string,
    model: string,
    type: string,
    unit_nominal: string,
    
    
    mvatPh: string,
    responseTime: string,
    value1: string,
    value2: string,
    value3: string,
    value4: string,
    


    ////Mohit
    temperature_Air_before: string,
    temperature_Air_after: string,

    humidity_Air_before: string,
    humidity_Air_after: string,

    pressure_before: string,
    pressure_after: string,

}

export function Empty_DataEntity_Main_11_01_Interface(): DataEntity_Main_11_01_Interface {
    return {
        id: 0,
        calibration_id: 0,
        manufacture: '',
        model: '',
        type: '',
        unit_nominal: '',


        mvatPh: '',
        responseTime: '',
        value1: '',
        value2: '',
        value3: '',
        value4: '',

        ////Mohit


        temperature_Air_before: '',
        temperature_Air_after: '',

        humidity_Air_before: '',
        humidity_Air_after: '',

        pressure_before: '',
        pressure_after: '',


    }
}
